'use strict';

/**
 * @function
 * @description Checks the passed location hash returns the cleaned or empty string
 * @param {String} hash The location hash
 */
const getLocationHash = (hash) => {
    return (!hash || hash.length === 0) ? '' : hash.substr(1);
};

module.exports = getLocationHash;
